import React from 'react';
import { Mail, ArrowRight } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-20 bg-gradient-to-b from-white to-gray-50 relative overflow-hidden" data-id="element-9">
      {/* Subtle Background Elements */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-[#f59e0b]/5 rounded-full blur-3xl pointer-events-none" data-id="element-10"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-11">
        <div className="max-w-4xl mx-auto" data-id="element-12">
          {/* Header */}
          <div className="text-center mb-12" data-id="element-13">
            <span className="text-[#f59e0b] font-bold tracking-wider uppercase text-sm bg-[#f59e0b]/10 px-4 py-2 rounded-full" data-id="element-14">
              Get In Touch
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0a1628] mt-6 mb-3" data-id="element-15">
              Let's Work Together
            </h2>
            <p className="text-gray-600 max-w-xl mx-auto" data-id="element-16">
              Have a project in mind? We'd love to hear from you.
            </p>
          </div>

          {/* Contact Card */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-17">
            <div className="grid md:grid-cols-[1fr,auto] items-center" data-id="element-18">
              {/* Left Side - Info */}
              <div className="p-8 md:p-10" data-id="element-19">
                <div className="flex items-start gap-4 mb-6" data-id="element-20">
                  <div className="w-12 h-12 bg-[#f59e0b]/10 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-21">
                    <Mail className="w-6 h-6 text-[#f59e0b]" data-id="element-22" />
                  </div>
                  <div data-id="element-23">
                    <h3 className="text-lg font-bold text-[#0a1628] mb-1" data-id="element-24">
                      Email Us
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-25">
                      We typically respond within 24 hours
                    </p>
                  </div>
                </div>

                <a href="mailto:info@nawattech.com" className="group inline-flex items-center gap-3 text-2xl font-bold text-[#0a1628] hover:text-[#f59e0b] transition-colors" data-id="element-26">
                  info@nawattech.com
                  <ArrowRight className="w-6 h-6 transform group-hover:translate-x-1 transition-transform" data-id="element-27" />
                </a>
              </div>

              {/* Right Side - CTA */}
              <div className="bg-gradient-to-br from-[#0a1628] to-[#1a2a48] p-8 md:p-10 md:min-h-full flex flex-col justify-center" data-id="element-28">
                <div className="text-white" data-id="element-29">
                  <p className="text-sm font-medium text-gray-300 mb-2" data-id="element-30">
                    Ready to start?
                  </p>
                  <h4 className="text-xl font-bold mb-4" data-id="element-31">Send us a message</h4>
                  <a href="mailto:info@nawattech.com" className="inline-flex items-center justify-center px-6 py-3 bg-[#f59e0b] hover:bg-[#d97706] text-white font-bold rounded-lg transition-all text-sm shadow-lg shadow-orange-500/20 hover:shadow-orange-500/40 transform hover:-translate-y-0.5" data-id="element-32">
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 text-center" data-id="element-33">
            <p className="text-sm text-gray-500" data-id="element-34">
              Based in Dubai, UAE • Serving clients worldwide
            </p>
          </div>
        </div>
      </div>
    </section>;
}